module.exports = __webpack_public_path__ + "img/logo-web.8e7a707b.svg";